import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfDestaquesSchema } from './schema';

/**
 * Formulário da barra lateral.
 *
 * Vive num componente próprio porque os campos `object_browser` aninhados no
 * `object_list` só funcionam sob `withObjectBrowser` — mesmo arranjo do bloco
 * `homeBannerPortal` (`HomeBanner/Data.tsx`).
 *
 * `activeObject`/`setActiveObject` vêm do `Edit.tsx` e entram no *field spec*
 * de `items`: é assim que o `ObjectListWidget` do core aceita um índice
 * externo (ele só usa o par quando ambos estão presentes), e é o que permite
 * ao lápis de cada card abrir o item correspondente.
 */
const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfDestaquesSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  // Sem isto o `dataAdapter` registrado em `blocksConfig` nunca roda e o
  // preenchimento automático a partir da notícia não acontece.
  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        dataAdapter({ block, data, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
